<template>
  <v-list class="pt-0" dense>
    <v-divider light></v-divider>
    <v-list-tile v-for="channel in channels"
    :key="channel.id"
    :class="{'is_active': setChannelActive(channel)}"
    @click="changeChannel(channel)">
      <v-list-tile-content>
        <v-list-tile-title># {{ channel.name }}<div class="ui label purple channel__count" v-if="getNotification(channel) > 0 && channel.id !== currentChannel.id">{{ getNotification(channel) }}</div></v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'
import firebase from 'firebase'
import mixin from '../mixins'

export default {
  name: 'channels',
  data () {
    return {
      channels: [],
      new_channel: '',
      channelsRef: firebase.database().ref('channels'),
      messagesRef: firebase.database().ref('messages'),
      errors: [],
      firstLoad: true,
      notifCount: [],
      channel: null
    }
  },
  mixins: [mixin],
  computed: {
    ...mapGetters(['currentChannel', 'isPrivate']),
    hasErrors () {
      return this.errors.length > 0
    }
  },
  watch: {
    isPrivate () {
      if (this.isPrivate) {
        this.resetNotifications()
      }
    }
  },
  mounted () {
    this.addListeners()
  },
  methods: {
    addListeners () {
      this.channelsRef.on('child_added', snap => {
        this.channels.push(snap.val())

        if (this.firstLoad && this.channels.length > 0) {
          this.$store.dispatch('setCurrentChannel', this.channels[0])
          this.channel = this.channels[0]
        }
        this.firsLoad = false

        this.addCountListener(snap.key)
      })
    },
    addCountListener (channelId) {
      this.messagesRef.child(channelId).on('value', snap => {
        this.handleNotifications(
          channelId,
          this.currentChannel.id,
          this.notifCount,
          snap
        )
      })
    },
    getNotification (channel) {
      let notif = 0

      this.notifCount.forEach(el => {
        if (el.id === channel.id) {
          notif = el.notif
        }
      })
      return notif
    },
    openChannelModal () {

    },
    addChannel () {
      this.errors = []
      let key = this.channelsRef.push().key

      let newChannel = { id: key, name: this.new_channel }
      this.channelsRef
        .child(key)
        .update(newChannel)
        .then(() => {
          this.new_channel = ''
        })
        .catch(error => {
          this.errors.push(error.message)
        })
    },
    changeChannel (channel) {
      this.resetNotifications()
      this.$store.dispatch('setPrivate', false)
      this.$store.dispatch('setCurrentChannel', channel)
      this.channel = channel
    },
    resetNotifications () {
      let index = this.notifCount.findIndex(el => el.id === this.channel.id)
      if (index !== -1) {
        this.notifCount[index].total = this.notifCount[index].lastKnownTotal
        this.notifCount[index].notif = 0
      }
    },
    detachListeners () {
      this.channelsRef.off()
      this.channels.forEach(el => {
        this.messagesRef.child(el.id).off()
      })
    },
    setChannelActive (channel) {
      return channel.id === this.currentChannel.id
    }
  },
  beforeDestroy () {
    this.detachListeners()
  }
}
</script>



// WEBPACK FOOTER //
// Channels.vue?7267eeac